// extracted by mini-css-extract-plugin
export default {"progressBase":"ProgressBar_progressBase__Nrj8z","progress":"ProgressBar_progress__Fl1kp"};